import React from 'react';

export function CardSkeleton() {
  return (
    <div className="bg-white/5 border border-white/10 rounded-lg overflow-hidden">
      {/* Text content loads first */}
      <div className="p-2 space-y-2">
        <div className="h-4 bg-white/10 rounded w-2/3 animate-pulse" />
        <div className="flex justify-between items-center">
          <div className="h-3 bg-white/10 rounded w-1/4 animate-pulse" />
          <div className="h-3 bg-white/10 rounded w-1/4 animate-pulse" />
        </div>
      </div>
      
      {/* Image placeholder loads after text */}
      <div className="relative aspect-[2.5/3.5] bg-white/10 animate-pulse delay-100" />
    </div>
  );
}

export function CardGridSkeleton() {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 gap-2 sm:gap-3 lg:gap-4">
      {Array(12).fill(0).map((_, i) => (
        <CardSkeleton key={i} />
      ))}
    </div>
  );
}